export default {
  // 日期選擇器
  rangeSeparator: "至",
  startDate: "開始日期",
  endDate: "結束日期",

  // 搜索
  searchTxHash: "搜索交易哈希",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 數據統計
  totalData: "共計",
  dataUnit: "條數據",

  // 消息提示
  alreadyCurrentPage: "已經是當前地址詳情頁!",
};
